var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFtpCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_45234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5809 24.5673C47.5809 11.4824 36.9735 0.875 23.8886 0.875C10.8037 0.875 0.196289 11.4824 0.196289 24.5673C0.196289 37.6522 10.8037 48.2596 23.8886 48.2596C36.9735 48.2596 47.5809 37.6522 47.5809 24.5673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2678 29.6711C22.4955 29.4276 22.7658 29.2344 23.0632 29.1028C23.3605 28.9711 23.6792 28.9035 24.0009 28.9038C24.3227 28.904 24.6412 28.9722 24.9384 29.1044C25.2356 29.2366 25.5055 29.4302 25.7328 29.6741C25.9602 29.9181 26.1404 30.2076 26.2633 30.5263C26.3862 30.8449 26.4493 31.1863 26.4491 31.531C26.4488 31.8757 26.3852 32.2171 26.2618 32.5354C26.1384 32.8538 25.9577 33.1431 25.73 33.3866C25.27 33.8785 24.6464 34.1545 23.9965 34.1538C23.3465 34.1531 22.7235 33.8758 22.2643 33.3829C21.8052 32.89 21.5477 32.2219 21.5483 31.5255C21.549 30.8291 21.8078 30.163 22.2678 29.6711ZM14.7596 25.5386C19.8556 20.0786 28.1437 20.0786 33.2397 25.5386L30.9296 28.0136C29.0905 26.0468 26.5981 24.9422 23.9996 24.9422C21.4011 24.9422 18.9088 26.0468 17.0696 28.0136L14.7596 25.5386ZM10.1396 20.5886C17.7836 12.4001 30.2156 12.4001 37.8596 20.5886L35.5497 23.0636C29.1796 16.2386 18.8196 16.2386 12.4496 23.0636L10.1396 20.5886Z",
    fill: "#208DE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_45234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.0498047 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFtpCircle);
export default __webpack_public_path__ + "static/media/WhiteFTPCircle.51c0a98d8c057b138298ae2ffa6fb487.svg";
export { ForwardRef as ReactComponent };